import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { cn } from "./cn.js";
export function Tabs({ className, tablist = false, select, children, ...rest }) {
    return (_jsxs("div", { className: cn("fwfa-tabs", className), role: tablist ? "tablist" : undefined, "data-tabs": select !== undefined ? "select" : undefined, ...rest, children: [children, select] }));
}
export function Tab({ selected, pressed, className, type = "button", ...rest }) {
    return (_jsx("button", { type: type, role: selected === undefined ? undefined : "tab", "aria-selected": selected, "aria-pressed": pressed, className: cn("fwfa-tab", className), ...rest }));
}
//# sourceMappingURL=Tabs.js.map